export const detectState = (state: number, setroundState: (arg: string) => void) => {
    switch (state) {
        case 1:
            setroundState("COUNTER")
            break
        case 2:
            setroundState("PLAY")
            break
        case 3:
            setroundState("END")
            break

        default:
            break
    }
}


export const gameAbortHandler = (ctx: any, state: number) => {
    // 'cashout', 'cancelBet', 'cancelAuto', 'cashoutAuto',
    ctx.funcs.handleErrorText('Sorry, something went wrong, please reload the page')
    if (ctx.footerState === 'cashout' || ctx.footerState === 'cashoutAuto') {
        ctx.astroSocketMessages.cashout()
    }

    if ((ctx.footerState === 'cancelBet' || ctx.footerState === 'cancelAuto') && state !== 1) {
        ctx.astroSocketMessages.cancelBet()
    }
}